import apiClient from '../../../../api/apiConfig';
import { WorkflowServerExpect } from '../../ServerWorkflowType';

const BASE_URL = '/csb/workflows';

export const exportWorkflowToXML = async (
  workflow: WorkflowServerExpect
): Promise<string> => {
  const response = await apiClient.post<string>(`${BASE_URL}/export`, workflow);
  return response.data;
};
